$(document).ready(function(){ 
  if ($(window).width() < 1024) {
    setTimeout(function() {
var swiper = new Swiper('.swiper-container', {
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
          slidesPerView: 1,
      },
    });
      

      $('a[data-slide]').click(function(e) {
   e.preventDefault();
   var slideno = $(this).data('slide');
   $('.slider-for').slick('slickGoTo', slideno - 1);
 });
      }, 50);
    }


   $(window).resize(function(){
   if ($(window).width() < 1024) {
     var swiper = new Swiper('.swiper-container', {
      scrollbar: {
        el: '.swiper-scrollbar',
        slidesPerView: 1,
        hide: false,
      },
    });

   }
});
  });


$('.product-single__details select, .product-single__details input').bind('click change', function(){
  var get_handle = $('#Get_handle').val();
  setTimeout(function(){
  // var s_val = $('.product-single__variants option:selected').val();
     var s_val = $('.product-single__variants').val();
  console.log(s_val);
  $.getJSON('/products/'+get_handle+'.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.id == s_val) {
                var var_title = v.title;
                //console.log(v.featured_image.src);
                AodLoadVariantImages(var_title,v.featured_image.src,v.featured_image.alt);
              }
            });
          });
   }, 50);
  });


function AodLoadVariantImages (variant,featured,alt){
    var product_json;
  //console.log(variant);
     
    if(variant == null){
      return false;
    }
    
    //slick destroy
    if ($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('destroy');
    }  
    
  if ($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('destroy');
    }  

        
    if(variant && variant != 'Default Title'){
      var selected_image_html = '';
      var get_color_set_images;
      var get_color_set_images_for_slider;
      var img_alt = variant;
      
      if(featured != null){
        if(alt != null){
      		img_alt = alt; 
        }
      }
      

      if(featured != null){
          selected_image_html += '<div class="get-image-item swiper-slide" data-target="'+ img_alt +'">';
          selected_image_html += '<img src="'+ featured +'" alt="'+ img_alt +'">';
          selected_image_html += '</div>';
      }
      
      if($('.slider-for').length>0){
        $('.slider-for').empty();
      }
      if($('.slider-nav').length>0){
        $('.slider-nav').empty();
      }
      
      
      if(selected_image_html){
  
          $('.slider-for').html( selected_image_html );
          $('.slider-nav').html( selected_image_html );

      }
      
      
      if(variant){
        var getTitle = variant; 
        var handleize = getTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''); 
         console.log(handleize);
        if($('.slider-for').length>0){                 
          if($('#all_product_images [data-target="'+ handleize +'"]').clone().length > 0){     
            $('#all_product_images [data-target="'+ handleize +'"]').clone().appendTo( ".slider-for" );
          }
        }

        if($('.slider-nav').length>0){
          if($('#all_product_images [data-target="'+ handleize +'"]').clone().length > 0){
            $('#all_product_images [data-target="'+ handleize +'"]').clone().appendTo( ".slider-nav" );
          }
        }
      }
      
      //Get common images 
      if($('#all_product_images [data-target="common_image"]').clone().length > 0){ 
        if($('.slider-for').length>0){ 
          $('#all_product_images [data-target="common_image"]').clone().appendTo( ".slider-for" );
        }
        
        if($('.slider-nav').length>0){
          $('#all_product_images [data-target="common_image"]').clone().appendTo( ".slider-nav" );
        }
      }
      
     if ($(window).width() < 1024) {      
var swiper = new Swiper('.swiper-container', {
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        
      },
    });
       
       
    }
              
    }
    else{
      if($('.slider-for').length>0){
        $('.slider-for').html( $('#all_product_images').html() );
        $('.slider-nav').html( $('#all_product_images').html() );
      }
    }
    
   
   
  }

 jQuery(document).ready(function() {
            jQuery(".vedio_containers").click(function() {
                if (jQuery("#video").get(0).paused) {
                    jQuery("#video").trigger('play');
                    jQuery(".play").fadeOut(500);
                  jQuery(".overlay-video_1").fadeOut(500);
                    
                } else {
                    jQuery("#video").trigger('pause');
                    jQuery(".play").fadeIn(500);
                  jQuery(".overlay-video_1").fadeIn(500);
                }
            });
        });

//$(".yt_video_main #yt_video")[0].src += "?autoplay=0&controls=0&play=0&playsinline=1&mute=1";
$(".overlaybtn_yt").click(function () {
  $(this).hide();
    $(".overlay-video_yt").hide();
      $(".yt_video_main #yt_video")[0].src += "";
    $(".yt_video_main #yt_video")[0].src += "?autoplay=1&controls=1&play=1&playsinline=1";
   // $("#yt").show();
    });



// ------ Complete your kit ---------


$('body').on('click', '.Complete_kit_button', function (e) {
   e.preventDefault();
   e.stopPropagation();
   $(this).addClass('is-loading');
  
    var BundleItems = [];
    $('.kit_product_inputfield').each(function () {
        if ($(this).is(':checked')) {
            var VariantID = $(this).data('variant-id');
            console.log(VariantID, 'VariantID');

            BundleItems.push({
                quantity: 1,
                id: VariantID
            });
        }
    });

    if (BundleItems.length > 0) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({ items: BundleItems }),
                success: function (data) {
                  console.log('Added to cart');
                  $(this).removeClass('is-loading');
                  $('.product__form__wrapper form button[name="add"]').trigger('click');
                },
                error: function (error) {
                    console.error('Add to cart failed:', error);
                }
            });
     } else {
          $(this).addClass('is-loading');
          //$(this).removeClass('is-loading');
          $('.product__form__wrapper form button[name="add"]').trigger('click');
          console.log('No items selected to add.');
    }
});

